import { put, takeLatest, all, select } from 'redux-saga/effects';
import { API_URL } from 'containers/App/constants';
import { LOAD_DELIVERY_TIMES, LOAD_BROKERS, SET_OFFER_BROKER, LOAD_PRODUCTS } from './constants'
import { setDeliveryTimes, setBrokers, setProducts } from './actions';
import { makeSelectBroker } from './selectors';
import { getRequestHeadersAsLogged, responseHandler } from '../../utils/auth';

function* fetchDeliveryTimes() {
  const requestURL = `${API_URL}catalog/delivery-times`;

  try {
    const parameters = {
      method: 'GET',
      headers: getRequestHeadersAsLogged(),
    };

    const response = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );

    yield put(setDeliveryTimes(response));
  } catch (err) {
    console.log('request error', err);
  }
}

function* fetchBrokers() {
  const requestURL = `${API_URL}catalog/brokers`;

  try {
    const parameters = {
      method: 'GET',
      headers: getRequestHeadersAsLogged(),
    };

    const response = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );

    yield put(setBrokers(response));
  } catch (err) {
    console.log('request error', err);
  }
}

function* fetchProducts() {
  const selectedBroker = yield select(makeSelectBroker());

  if (selectedBroker) {
    const requestURL = `${API_URL}catalog/products?provider=${selectedBroker}`;

    try {
      const parameters = {
        method: 'GET',
        headers: getRequestHeadersAsLogged(),
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );

      yield put(setProducts(response));
    } catch (err) {
      console.log('request error', err);
    }
  }
}

function* actionWatcher() {
  yield takeLatest(LOAD_DELIVERY_TIMES, fetchDeliveryTimes);
  yield takeLatest(LOAD_BROKERS, fetchBrokers);
  yield takeLatest([SET_OFFER_BROKER, LOAD_PRODUCTS], fetchProducts);
}

export default function* offerValueData() {
  yield all([actionWatcher()]);
}
